
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"10","height":"10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.785 9.786a.73.73 0 01-.519.214.714.714 0 01-.522-.21L5.001 6.046 1.257 9.79a.743.743 0 01-1.2-.241A.73.73 0 010 9.267a.714.714 0 01.21-.522l3.745-3.744L.213 1.259A.74.74 0 01.732.001a.769.769 0 01.525.215l3.744 3.743L8.741.22A.72.72 0 019.268 0 .73.73 0 0110 .74a.75.75 0 01-.215.523l-3.74 3.74 3.744 3.743a.75.75 0 01-.004 1.04z","fill":"#333"}})])
          )
        }
      }
    